"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const dayjs_1 = __importDefault(require("dayjs"));

const index_1 = require("../../../index");

const references = __importStar(require("../../../common/casualReferences"));

const PATTERN = /今日|当日|昨日|明日|今夜|今夕|今晩|今朝/i;

class JPCasualDateParser {
  pattern() {
    return PATTERN;
  }

  extract(context, match) {
    const text = match[0];
    const date = dayjs_1.default(context.refDate);
    const components = context.createParsingComponents();

    switch (text) {
      case "昨日":
        return references.yesterday(context.reference);

      case "明日":
        return references.tomorrow(context.reference);

      case "今日":
      case "当日":
        return references.today(context.reference);
    }

    if (text == "今夜" || text == "今夕" || text == "今晩") {
      components.imply("hour", 22);
      components.assign("meridiem", index_1.Meridiem.PM);
    } else if (text.match("今朝")) {
      components.imply("hour", 6);
      components.assign("meridiem", index_1.Meridiem.AM);
    }

    components.assign("day", date.date());
    components.assign("month", date.month() + 1);
    components.assign("year", date.year());
    return components;
  }

}

exports.default = JPCasualDateParser;